// @flow

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch ( props.decorator || props.is ) {
    case 'RadioSelect':
    case 'CheckboxSelect':
      return import('fg-frontend/src/components/RadioSelect');
    case 'SimpleCollapse':
      if ( (typeof (props.storeCookie) == 'undefined') || ((props.storeCookie).indexOf('CATEGORY_FILTER') != 0) ) {
        return import('fg-frontend/components/SimpleCollapse');
      } else {
        return null;
      }
    case 'Typeahead':
      return import('fg-frontend/components/Typeahead');
    case 'SelectDesign':
      return import('./components/SelectDesign');
    case 'ListToggle':
      return import('fg-frontend/components/ListToggle');
    case 'PasswordToggle':
      return import('fg-frontend/components/PasswordToggle');
    case 'SocialShare':
      return import('fg-frontend/components/SocialShare');
    case 'AnchorsList':
      return import('fg-frontend/src/components/AnchorsList');
    case 'Slider':
      return import('fg-frontend/components/Slider');
    case 'RadioSelectTab':
      return import('fg-frontend/src/components/RadioSelectTab');
    case 'NumberInput':
      return import('fg-frontend/components/NumberInput');
    case 'UniversalPaginationButton':
      return import('fg-frontend/components/UniversalPaginationButton');
    case 'TokenInput':
      return import('./components/TokenInput');
    case 'Tooltip':
      return import('./components/Tooltip');
    case 'GtmHandler':
      return import('./components/GtmHandler');
    case 'TriggerInViewport':
      return import('./components/TriggerInViewport');
    case 'RedirectToUrl':
      return import('fg-frontend/src/components/RedirectToUrl');
    case 'LazyImage':
      return import('./components/LazyImage');
    case 'Webslider':
      return import('./components/Webslider');
    case 'PrintPdf':
      return import('fg-frontend/src/components/PrintPdf');
    case 'FileInput':
      return import('fg-frontend/src/components/FileInput');
    case 'RangeDatepicker':
      return import('fg-frontend/components/RangeDatepicker');
    case 'Execute':
      return import('./components/Execute');
    case 'PreventDoubleClickHandler':
      return import('fg-frontend/src/components/PreventDoubleClickHandler');
    case 'GoogleRecaptcha':
      return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'MainMenu':
      return import('./components/MainMenu');
    default:
      const eshopComponent = configureEshopComponents(props);
      if ( eshopComponent ) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${ props.decorator || props.is }`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js